import { BacklinksIcons } from './Backlinks';
import { FilesIcon } from './FilesIcon';
import { KeywordsIcon } from './Keywords';
import * as ModuleIcons from './module-icons';
import { PaymentsIcon } from './Payments';
import { VisibleIcon } from './Visible';

export * from './Account';
export * from './AccountOutlined';
export * from './AlertCircle';
export * from './AlertFilled';
export * from './ArrowDown';
export * from './ArrowNe';
export * from './ArrowRight';
export * from './Article';
export * from './AutoModel';
export * from './auth-icons';
export * from './Back';
export * from './Backlinks';
export * from './Bank';
export * from './BankCard';
export * from './Billing';
export * from './BookOpen';
export * from './CancelInvoice';
export * from './CaretRight';
export * from './ChatBubble';
export * from './ChatGPTIcon';
export * from './Check';
export * from './Checkbox';
export * from './CheckboxChecked';
export * from './CheckedCircle';
export * from './ChevronDown';
export * from './ChevronRight';
export * from './ClaudeIcon';
export * from './Clients';
export * from './Clock';
export * from './Close';
export * from './Company';
export * from './CopilotBrandingIcon';
export * from './CopilotLogo';
export * from './Copy';
export * from './Core';
export * from './CreditCard';
export * from './CreditCardFilled';
export * from './CrossIcon';
export * from './custom-fields';
export * from './Customization';
export * from './Dashboard';
export * from './Date';
export * from './DefaultCompany';
export * from './Diamond';
export * from './DollarIcon';
export * from './DownloadIcon';
export * from './DropzoneFilesIcon';
export * from './Edit';
export * from './ErrorCloseMarkIcon';
export * from './Export';
export * from './ExtensionDisconnect';
export * from './Extensions';
export * from './ExternalLink';
export * from './Eye';
export * from './Facebook';
export * from './FileDropzone';
export * from './file-formats';
export * from './FilesIcon';
export * from './FileUploadIcon';
export * from './FolderFill';
export * from './Forms';
export * from './FormsFilled';
export * from './Forward';
export * from './Gem';
export * from './GoogleDrive';
export * from './Group';
export * from './Hamburger';
export * from './HeartFilled';
export * from './Info';
export * from './Instagram';
export * from './integrations';
export * from './Invisible';
export * from './Invoice';
export * from './Keywords';
export * from './LinkedIn';
export * from './LockIcon';
export * from './Logo';
export * from './MainSettings';
export * from './MassShareIcon';
export * from './Messages';
export * from './module-icons';
export * from './MoreActions';
export * from './MultiAnswer';
export * from './NoCompany';
export * from './NotificationIcon';
export * from './Pages';
export * from './PagesDark';
export * from './Paint';
export * from './PaintRoll';
export * from './PaperClip';
export * from './PauseIcon';
export * from './PaymentFailedIcon';
export * from './Payments';
export * from './People';
export * from './Play';
export * from './Plus';
export * from './Portal';
export * from './PortalBlack';
export * from './PortalModules';
export * from './Preview';
export * from './Puzzle';
export * from './Qrc';
export * from './QuestionIcon';
export * from './QuestionShortIcon';
export * from './QuickBooksIcon';
export * from './RatingStar';
export * from './ReadMessage';
export * from './Referrals';
export * from './Refresh';
export * from './Reorder';
export * from './Required';
export * from './Reset';
export * from './Search';
export * from './Send';
export * from './SendHorizontalIcon';
export * from './Shop';
export * from './Sidebar';
export * from './SidebarOpen';
export * from './signature-icons';
export * from './SlackIcon';
export * from './Smartphone';
export * from './snackbars/ErrorIcon';
export * from './snackbars/SuccessIcon';
export * from './snackbars/UploadIcon';
export * from './Stats';
export * from './StripeLogo';
export * from './Subscription';
export * from './SuccessCheckmark';
export * from './Survey';
export * from './Switch';
export * from './Task';
export * from './Team';
export * from './Template';
export * from './text-editor';
export * from './TimelineInvoiceIcon';
export * from './TrayFullOutline';
export * from './TrayOutline';
export * from './Tweet';
export * from './Twitter';
export * from './UnreadMessage';
export * from './User';
export * from './UserPlus';
export * from './VisaCard';
export * from './Visible';

const {
  AnalyticsIcon,
  BookIcon,
  ChatboxIcon,
  ClipboardIcon,
  ColorFilterIcon,
  ContractIcon,
  CubeIcon,
  FolderIcon,
  LinkIcon,
  PieChartIcon,
  ShapesIcon,
  SpeedometerIcon,
  ...otherModuleIcons
} = ModuleIcons;

export const PickerIcons = {
  contracts: ContractIcon,
  files: FilesIcon,
  folder: FolderIcon,
  forms: ClipboardIcon,
  knowledge: BookIcon,
  messages: ChatboxIcon,
  payments: PaymentsIcon,
  ...otherModuleIcons,
};

export const IconNameToComponent = {
  backlinks: BacklinksIcons,
  cube: CubeIcon,
  dashboard: SpeedometerIcon,
  extension: LinkIcon,
  keywords: KeywordsIcon,
  linegraph: AnalyticsIcon,
  piechart: PieChartIcon,
  shapes: ShapesIcon,
  venn: ColorFilterIcon,
  visible: VisibleIcon,
  ...PickerIcons,
};
export const iconPickerClassName = '[&>svg]:w-[40px]! [&>svg]:h-[40px]!';
export type IconType = KeyOf<typeof IconNameToComponent>;

export const isIconName = (val: string): val is IconType =>
  val in IconNameToComponent;

export const getIconName = (
  val: string,
  fallback: IconType = 'AppsIcon',
): IconType => (isIconName(val) ? val : fallback);

export const getIconElement = (
  val: string,
  fallback: IconType = 'AppsIcon',
): ValueOf<typeof IconNameToComponent> => {
  if (isIconName(val)) {
    return IconNameToComponent[val];
  }
  return IconNameToComponent[fallback];
};
